import type { SectionHeader } from "../types";

/** 板块通用头部：小标题 + 标题 + 可选引导语。各 section 复用。 */
export function renderSectionHeader(h: SectionHeader): string {
  return `
    <header class="sec-head" data-reveal>
      <div class="eyebrow">${h.eyebrow}</div>
      <h2>${h.title}</h2>
      ${h.intro ? `<p class="sec-intro">${h.intro}</p>` : ""}
    </header>`;
}
